import { titleColorCss } from "./title-presentation.js";
import { titleRequiredCount } from "./title-progress.js";
import { provenanceRailMarkup } from "../components/provenance-indicator.js";
import { provenanceIndicatorColorForTone } from "../components/provenance-tone.js";

// Comparison is between public acquisition evidence and the currently used
// requirement, never the player's personal capture count. Reports expose no
// distribution, so a difference is not an uncertainty interval.
export function titleReportComparison(title) {
  const current = titleRequiredCount(title);
  if (title.reports.count === 0) return { kind: "unreported", current };
  const average = title.reports.average;
  return {
    kind: title.requirement === null ? "estimated" : "reference",
    current,
    average,
    difference: current === null ? null : average - current,
  };
}

export function titleEvidenceSegments(title, { text, number }) {
  const segment = (key, tone, rows) => ({
    segmentId: `title-${title.titleId}-${key}`,
    label: text(key), sourceLabel: text(key), active: true,
    color: provenanceIndicatorColorForTone(tone),
    claims: [{
      laneId: `title:${title.titleId}:${key}`, status: "effective",
      card: { summary: title.name || text("name_unknown", { id: title.titleId }), summaryColor: titleColorCss(title), badge: text(key), tone,
        rows: rows.map(([label, value]) => ({ label, value })) },
    }],
  });
  const segments = [];
  if (title.kind !== "catch") return segments;
  if (title.requirement) {
    const { minimum, maximum, source } = title.requirement;
    segments.push(segment("reference_source", "imported", [
      [text("used_requirement"), minimum === maximum ? number(minimum) : `${number(minimum)}–${number(maximum)}`],
      [text("reference_source"), source],
    ]));
  }
  const comparison = titleReportComparison(title);
  const rows = comparison.kind === "unreported"
    ? [[text("community_evidence"), text("no_reports")]]
    : [
      [text("community_evidence"), text("reports", { count: number(title.reports.count), average: number(comparison.average) })],
      [text("used_requirement"), comparison.current === null ? text("unknown") : number(comparison.current)],
      [text("estimate_difference"), comparison.kind === "reference"
        ? text("difference_value", { count: `${comparison.difference > 0 ? "+" : ""}${number(comparison.difference)}` })
        : text("estimate_used")],
      [text("evidence_limits"), text("no_distribution")],
    ];
  segments.push(segment("community_evidence", comparison.kind === "unreported" ? "neutral" : "community", rows));
  return segments;
}

export function titleEvidenceMarkup(title, presentation) {
  return provenanceRailMarkup(titleEvidenceSegments(title, presentation), {
    label: presentation.text("provenance"),
  });
}
